import apiClient from '../apiClient';
import { POST_PAYMENT_SCHEME_DETAIL_URL } from '../apiUrl';

const postPaymentSchemeDetailApi = data => {
  return apiClient.post(POST_PAYMENT_SCHEME_DETAIL_URL, data);
};

export default postPaymentSchemeDetailApi;
